module.exports = __webpack_public_path__ + "media/images/features/draft/icon-point-02-a28d2ebc9dd95751a1df74363c839854.svg";